import { Box } from '@mui/material'
import type { FC } from 'react'

type Props = {
  x: number
  y: number
  color: string
}

/** BBox描画中にポインターの延長に表示する十字線。ガイド目的 */
export const Crosshair: FC<Props> = ({ x, y, color }) => (
  <>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: `${x}px`,
        width: '1px',
        height: '100%',
        backgroundColor: color,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: `${y}px`,
        width: '100%',
        height: '1px',
        backgroundColor: color,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    />
  </>
)
